import { makeStyles } from "@material-ui/core/styles";

export const useTrackingOrderStyles = makeStyles((theme) => ({
  containerAccordion: {
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: "12px",
    marginBottom: theme.spacing(2),
    "&:before": {
      display: "none",
    },
  },
  containerSummary: {
    backgroundColor: "#f8f9fa",
    borderRadius: "12px 12px 0 0",
    minHeight: "56px",
    "&.Mui-expanded": {
      minHeight: "56px",
    },
  },
  containerHeading: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#1a1a1a",
  },
  containerDetails: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  accordion: {
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    borderRadius: "8px",
    marginBottom: theme.spacing(1.5),
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: "0 0 12px 0",
    },
  },
  heading: {
    fontSize: "1rem",
    fontWeight: 500,
    color: "#2c3e50",
  },
  details: {
    padding: theme.spacing(2),
    backgroundColor: "#fafbfc",
    minHeight: 200,
    width: "100%",
  },
  infoCard: {
    borderRadius: "12px",
    border: "1px solid #e8eaed",
    boxShadow: "none",
    backgroundColor: "#ffffff",
    transition: "all 0.3s ease",
    minHeight: 150, // Altura mínima de la card
    display: "flex",
    width: "100%",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },
  },
  infoCardContent: {
    padding: "20px !important",
    width: "100%",
    boxSizing: "border-box",
    flex: 1,
    "&:last-child": {
      paddingBottom: "20px !important",
    },
  },
  label: {
    display: "block",
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#6c757d",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "6px",
  },
  value: {
    display: "block",
    fontSize: "0.95rem",
    fontWeight: 500,
    color: "#1a1a1a",
    lineHeight: "1.5",
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid #e8eaed",
  },
  cardHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  logoCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "#6c757d",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    fontWeight: 600,
  },
  cardTitleSection: {
    display: "flex",
    flexDirection: "column",
  },
  cardTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "2px",
  },
  cardSubtitle: {
    fontSize: "0.85rem",
    color: "#6c757d",
    marginBottom: "4px",
  },
  cardId: {
    fontSize: "0.75rem",
    color: "#adb5bd",
  },
  cardHeaderRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(0.5),
  },
  cardDate: {
    fontSize: "0.85rem",
    color: "#6c757d",
    marginBottom: "4px",
  },
  statusBadge: {
    fontSize: "0.8rem",
    fontWeight: 500,
    padding: "4px 12px",
    borderRadius: "12px",
    backgroundColor: "#fff3e0",
    color: "#f57c00",
  },
  editButton: {
    marginTop: "8px",
    minWidth: "36px",
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    backgroundColor: "#1976d2",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
}));